import type { Action } from '../../../actions/index.tsx';
import { type SetVersionDataAction, SET_VERSION_DATA } from '../../../actions/version/index.tsx';
import type { VersionDataState } from './types.tsx';

const initVersionDataState: VersionDataState = {
	versionsPerProject: {},
	canCreateVersion: false,
};

export const versionDataReducer = (
	state: VersionDataState = initVersionDataState,
	action: Action,
): VersionDataState => {
	if (action.type === SET_VERSION_DATA) {
		// eslint-disable-next-line @typescript-eslint/consistent-type-assertions
		const { payload } = action as SetVersionDataAction;
		return { ...payload };
	}

	return state;
};
